import { gql } from "@apollo/client"

export const CREATE_DOCUMENT = gql`
    mutation CreateDocument($record: CreateOneDocumentInput!) {
        createDocument(record: $record) {
            uploadUrl
            record {
                path
                thumbnailPath
                fileName
            }
        }
    }
`
